module.exports = "https://web-assets.ifttt.com/packs/media/icons/turned_off-3c7093ea.png";